export const hasBillingDescriptors = (entities) => {
  return entities.some(
    (item) => Array.isArray(item.billing_descriptors) && item.billing_descriptors.length > 0
  )
}

export const hasEmptyVisaData = (entities) => {
  return entities.every(
    ({ visa_arn_codes, visa_bin_codes, visa_caid_codes }) =>
      !visa_arn_codes?.length && !visa_bin_codes?.length && !visa_caid_codes?.length
  )
}

export const hasVisaData = (entities) => {
  return entities.some(
    ({ visa_arn_codes, visa_bin_codes, visa_caid_codes }) =>
      visa_arn_codes?.length > 0 || visa_bin_codes?.length > 0 || visa_caid_codes?.length > 0
  )
}

export const hasRdrEnabled = (entities = []) => {
  return entities.some((item) => item.name === "RDR" && item.is_active)
}
